<!--配置首页常用模块-->
<template>
  <Drawer
    :title="$t('home.my_menus_config')"
    placement="right"
    class="menuconfig-container"
    :width="300"
    :closable="false"
    :value="showModal"
    @on-close="onClose"
  >
    <div class="cardconfig-inner">
      <Card class="cmenu-item" v-for="(menu, index) in menuList" :key="index" dis-hover>
        <p slot="title">{{ menu.privilegeDesc }}</p>
        <div class="child-item" v-for="(child, childIndex) in menu.children" :key="childIndex">
          <label class="menu-name">{{ child.privilegeDesc }}</label
          ><i-switch v-model="child.open"></i-switch>
        </div>
      </Card>
    </div>
    <div class="bottom-save">
      <Button class="ok-btn" @click="handleSubmit()">{{ $t('common.save') }}</Button>
    </div>
  </Drawer>
</template>

<script>
import api from '../../../api/home/index';
import { subscribeMenuList } from '../subscribeConfig';
export default {
  components: {},
  computed: {
    servers() {
      return this.$system.$state.servers;
    },
  },
  props: {
    showModal: {
      require: true,
      type: Boolean,
    },
    subscribeList: {
      require: true,
      type: Array,
    },
  },
  watch: {
    showModal(nv) {
      if (nv) {
        let menus = this.$system.$state.menuList;
        let list = [];
        //将三层菜单列表转为两层,获取可订阅的模块数据
        menus.forEach(menu => {
          const arr = JSON.parse(JSON.stringify(menu.menus));

          arr.forEach(a => {
            if (a.children && a.children.length > 0) {
              const childList = [];
              a.children.forEach(c => {
                if (subscribeMenuList[c.privilegeName]) {
                  childList.push(c);
                }
              });
              if (childList.length > 0) {
                a.children = childList;
                list.push(a);
              }
            } else {
              if (subscribeMenuList[a.privilegeName]) {
                a.children = [a];
                list.push(a);
              }
            }
          });
        });
        //根据用户已订阅的模块处理列表状态
        list.forEach(menu => {
          menu.children &&
            menu.children.forEach(child => {
              let index = this.subscribeList.findIndex(sub => {
                return sub.key === child.privilegeName;
              });
              child.open = index !== -1;
            });
        });
        this.menuList = list;
      }
    },
  },
  data() {
    return {
      menuList: [],
    };
  },
  created() {},
  methods: {
    onClose() {
      this.$emit('on-close');
    },
    handleSubmit() {
      let ids = [];
      this.menuList.forEach(menu => {
        menu.children &&
          menu.children.forEach(child => {
            if (child.open) {
              if (!subscribeMenuList[child.privilegeName]) {
                console.log('缺少模块配置-------------', child.privilegeName);
                return;
              }
              ids.push(subscribeMenuList[child.privilegeName].id);
            }
          });
      });
      if (ids.length === 0) {
        this.$Message.error(this.$t('home.my_menus_config_error1'));
        return;
      }
      api
        .saveUserWebModules({
          modules: ids.join(','),
        })
        .then(() => {
          this.$Message.success(this.$t('common.save_success'));
          this.$emit('refresh');
          this.onClose();
        })
        .catch(() => {
          this.$Message.error(this.$t('common.save_error'));
        });
    },
  },
};
</script>
<style lang="scss" type="text/scss">
.menuconfig-container {
  .cardconfig-inner {
    height: calc(100% - 55px);
    overflow: auto;
  }

  .ivu-divider-inner-text {
    font-size: 12px;
  }

  .ivu-card {
    font-size: 14px;
  }

  .ivu-drawer-header-inner,
  .ivu-card-head p {
    font-weight: bold;
  }

  .cmenu-item {
    margin: 10px;

    .ivu-card-body {
      padding: 5px 10px;
    }
  }

  .child-item {
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
  }

  .bottom-save {
    margin-top: 5px;
    height: 50px;
  }

  .ivu-drawer-wrap {
    z-index: 9999;
  }

  .ivu-drawer-body {
    padding-bottom: 0;
  }

  .cardconfig-inner {
  }

  .ok-btn {
    width: 100%;
    padding: 6px 15px;
    background: $secondary-color;
    color: #fff;
    font-size: 14px;
    border: 1px solid $secondary-color;
  }

  .ok-btn:hover {
    background: $secondary-color-hover;
    color: #fff;
  }

  .ivu-switch-checked {
    background-color: $green-color;
    border-color: $green-color;
  }
}
</style>
